import {
  GET_K8S_INTEGRATIONS,
  CREATE_K8S_INTEGRATION,
  DELETE_K8S_INTEGRATION,
} from "../actions/k8sIntegrationActions";

const initialState = {
  integrations: [],
};

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case GET_K8S_INTEGRATIONS:
      return { ...state, integrations: payload.integrations };

    case CREATE_K8S_INTEGRATION:
      return { ...state };

    case DELETE_K8S_INTEGRATION:
      return { ...state };

    default:
      return state;
  }
}
